import Vue from 'vue'
import VueRouter from 'vue-router'
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)
const routes = [
  {
    path: "",
    redirect: "/collectImgAj"
  },

  {
    path: "/collectImgAj",
    name: "collectImgAj",
    component: () => import("../views/collect/collectImgAj.vue"),
    meta: {
      title: "收集头像"
    }
  },
  
  {
    path: "/text",
    name: "text",
    component: () => import("../views/collect/text.vue"),
    meta: {
      title: "收集花名册头像"
    }
  },
 
]


const router = new VueRouter({
  routes
})

export default router
